<template>
  <div
    class="cascader"
    :style="width?('min-width:'+width+'px'):''+','+height?('min-height:'+height+'px'):''"
  >
    <cascader-panel :data="data" @getAcived="getAcived" :width="width" :height="height"></cascader-panel>
  </div>
</template>

<script>
  import CascaderPanel from "./CascaderPanel";

  export default {
    name: "Cascader",
    components: {
      CascaderPanel
    },
    props: {
      data: Array,
      width: {
        type: [Number, String],
        default: 0
      },
      height: {
        type: [Number, String],
        default: 0
      }
    },
    methods: {
      // 获取当前激活的选项
      getAcived(dat) {
        // console.log('获取当前激活的选项 cascader ::',dat);
        this.$emit('getAcived', dat);
      },
    }
  };
</script>

<style scpoed>
  .cascader {
    position: absolute;
    min-height: 300px;
    background-color: #2b558d;
    color: #fff;
    box-sizing: border-box;
    /* box-shadow: 5px 5px 10px #ddd; */
    /* width: 11rem; */
  }
</style>
